module.exports = __webpack_public_path__ + "img/empty.ae7c57c3.png";